import React from 'react';
import MultiPoseItem from './MultiPoseItem';
import YearbookItem from './YearbookItem';
import IndividualAddonItem from './IndividualAddonItem';

const CartItem = ({
  orderPackage,
  removeItem,
  editable,
}) => {
  const isMultiPose = orderPackage.sheets.length > 0;
  const isYearbook = orderPackage.package.name.toLowerCase().includes('yearbook');
  const isPanorama = orderPackage.package.name.toLowerCase().includes('panorama');
  const isIndividualAddons = orderPackage.sheets.length === 0 && orderPackage.addonSheets.length > 0;

  if (isMultiPose) {
    return (
      <MultiPoseItem
        orderPackage={orderPackage}
        removeItem={removeItem}
        editable={editable}
      />
    );
  }

  if (isYearbook || isPanorama) {
    return (
      <YearbookItem
        orderPackage={orderPackage}
        removeItem={removeItem}
        editable={editable}
      />
    )
  }

  if (isIndividualAddons) {
    return (
      <IndividualAddonItem
        orderPackage={orderPackage}
        removeItem={removeItem}
        editable={editable}
      />
    );
  }

  return null;
};

export default CartItem;
